var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataAcquisitionBlueIcon = function SvgDataAcquisitionBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.917 3 21.5 7.5m0 0L16.917 12M21.5 7.5h-13M8.083 21 3.5 16.5m0 0L8.083 12M3.5 16.5h13"
  })));
};
export { SvgDataAcquisitionBlueIcon as ReactComponent };
export default __webpack_public_path__ + "ae29389941cf8ec4ceb3c946b7708b9b.svg";